import { TListingFetchReason, TRESPONSE_SPAREPART_LIST, TRESPONSE_SPAREPART_REQUEST_LIST } from '@monorepo/types';
import { TUserPaginationOption } from '@monorepo/ui';

export type TSparePartListState = {
  sparePartListingInfo: {
    res: TRESPONSE_SPAREPART_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  sparePartRequestListingInfo: {
    res: TRESPONSE_SPAREPART_REQUEST_LIST;
    fetchReason: TListingFetchReason;
  } | null;
  sparePartListingPagination: TUserPaginationOption;
  sparePartRequestPagination: TUserPaginationOption;
};

export const TSparePartListInfoActionType = {
  GetSparePartList: 'GET_SPAREPART_LIST' as const,
  GetSparePartListSuccess: 'GET_SPAREPART_LIST_SUCCESS' as const,
  GetSparePartListFailure: 'GET_SPAREPART_LIST_FAILURE' as const,
  SetSparePartListPagination: 'SET_SPARE_PART_LIST_PAGINATION' as const,
  UpdateSparePart: 'UPDATE_SPAREPART' as const,
  UpdateSparePartFailure: 'UPDATE_SPAREPART_SUCCESS' as const,
  UpdateSparePartSuccess: 'UPDATE_SPAREPART_FAILURE' as const,
  DeleteSpareParts: 'DELETE_SPAREPART' as const,
  DeleteSparePartsSuccess: 'DELETE_SPAREPART_SUCCESS' as const,
  DeleteSparePartsFailure: 'DELETE_SPAREPART_FAILURE' as const,
  SetSparePartRequestPagination: 'SET_SPARE_PART_REQUEST_PAGINATION' as const,
  GetSparePartRequestList: 'GET_SPAREPART_REQUEST_LIST' as const,
  GetSparePartRequestListSuccess: 'GET_SPAREPART_REQUEST_LIST_SUCCESS' as const,
  GetSparePartRequestListFailure: 'GET_SPAREPART_REQUEST_LIST_FAILURE' as const,
  BulkUpdateSparePartRequestStatus: 'BULK_UPDATE_SPAREPART_REQUEST_STATUS' as const,
  BulkUpdateSparePartRequestStatusFailure: 'BULK_UPDATE_SPAREPART_REQUEST_STATUS_SUCCESS' as const,
  BulkUpdateSparePartRequestStatusSuccess: 'BULK_UPDATE_SPAREPART_REQUEST_STATUS_FAILURE' as const,
  BulkUpdateSparePartThreshold: 'BULK_UPDATE_SPAREPART_THRESHOLD' as const,
  BulkUpdateSparePartThresholdFailure: 'BULK_UPDATE_SPAREPART_THRESHOLD_FAILURE' as const,
  BulkUpdateSparePartThresholdSuccess: 'BULK_UPDATE_SPAREPART_THRESHOLD_SUCCESS' as const,
  BulkUpdateSparePartCritical: 'BULK_UPDATE_SPAREPART_CRITICAL' as const,
  BulkUpdateSparePartCriticalFailure: 'BULK_UPDATE_SPAREPART_CRITICAL_FAILURE' as const,
  BulkUpdateSparePartCriticalSuccess: 'BULK_UPDATE_SPAREPART_CRITICAL_SUCCESS' as const,
};
